<template>
  <div>
    <v-data-table dense
                  :loading="loading"
                  :headers="headers"
                  :items="sessions"
                  :items-per-page="100">

      <template v-slot:item.id="{item: session}">
        <router-link :to="{name: `${$root.routePrefix}.device_session.show`, params: {sessionID: session.id}}">
          {{ session.id }}
        </router-link>
      </template>

      <template v-slot:item.live_mode="{item: session}">
        {{ session.live_mode ? 'Yes' : 'No' }}
      </template>

      <template v-slot:item.started_at="{item: session}">
        {{ session.started_at | datetime('YYYY-MM-DD h:mm a') }}
      </template>

      <template v-slot:item.duration="{item: session}">
        {{ session.duration ? session.duration_for_humans : '' }}
      </template>

      <template v-slot:item.entities="{item: session}">
        <template v-for="entity in session.entities">
          <div v-if="entity.crm_related_name"
               :key="entity.id">
            {{ entity.crm_related_name }}
          </div>
        </template>
      </template>

    </v-data-table>

  </div>
</template>
<script>

export default {
  props: {
    sessions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  data() {
    return {
      dialog: false,
      session: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Session ID',
          value: 'id',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Date',
          value: 'started_at',
          cellClass: 'text-nowrap',
        },
        {
          text: 'Presentation',
          value: 'presentation.name',
        },
        {
          text: 'Associated with',
          value: 'entities',
        },
        {
          text: 'Duration',
          value: 'duration',
          cellClass: 'text-nowrap',
        },
      ];
    }
  },
  methods: {
    updated() {
      this.$emit('updated');
      this.dialog = false;
    },
  }
}
</script>
